module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust4_m.c80bba29c54d939f4bb51fff4d241f09.png";